import { mergeSx } from "@/utils/styleHelpers";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

import { SvgIcon } from "../SvgIcon";

const LOGO_REFERENCE = "PlayVerticalLockup";

export function PlayVerticalLockup({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent(LOGO_REFERENCE);
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 123 112"
      sx={mergeSx({ w: "200px", fill: "base.color.brand.1" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}
PlayVerticalLockup.displayName = LOGO_REFERENCE;
